import { Image, Text, Tooltip } from "@chakra-ui/react";
import { getAssetLongName } from "@syla/shared/helpers/assets/getAssetLongName";
import { getAssetShortName } from "@syla/shared/helpers/assets/getAssetShortName";
import { isReceiveType } from "@syla/shared/types/models/LedgerBase";
import { Ledger } from "@syla/shared/types/responses/TransactionEvent";
import React from "react";
import { NumberStyler } from "../../../../../helper/NumberStyler";
import { getLedgerTypeIcon } from "../../../../../helper/transaction/getLedgerType";
import { formatNumberLocal } from "../../../../../helpers/formatNumberLocal";
import { ImageWithMissingSrc } from "../../../../atoms/ImageWithMissingSrc";
import { TableCell, TableRow } from "./Table";

export function StaticLedgerTableRow({
  ledger,
}: {
  ledger: Ledger;
}): React.ReactElement {
  const price = calculatePrice(ledger);

  return (
    <TableRow>
      <TableCell flexGrow={1.5}>
        <Image
          src={getLedgerTypeIcon(ledger.type)}
          alt=""
          w="2rem"
          h="2rem"
          mr="0.5rem"
        />
        <Text>{ledger.type}</Text>
      </TableCell>
      <TableCell>
        {isReceiveType({ type: ledger.type }) ?
          <Text color="green.500">+</Text>
        : <Text color="red.600">-</Text>}
        <NumberStyler
          fontSize="md"
          num={ledger.amount}
          colored
          signed={false}
        />
      </TableCell>
      <TableCell>
        <>
          <ImageWithMissingSrc
            src={ledger.asset.image}
            alt=""
            w="2rem"
            h="2rem"
            mr="0.5rem"
          />
          <Tooltip label={getAssetLongName(ledger.asset)}>
            <Text noOfLines={1}>{getAssetShortName(ledger.asset)}</Text>
          </Tooltip>
        </>
      </TableCell>
      <TableCell justifyContent="flex-end">
        <Tooltip
          shouldWrapChildren
          label={
            price ?
              `Price $${formatNumberLocal(price.toNumber(), {
                maximumFractionDigits: 2,
              })} AUD / Unit`
            : ""
          }
        >
          <NumberStyler
            fontSize="md"
            num={ledger.marketValue}
            textAlign="right"
            unit="currency"
          />
        </Tooltip>
      </TableCell>
    </TableRow>
  );
}

function calculatePrice(ledger: Ledger) {
  if (!ledger.marketValue) {
    return undefined;
  }

  if (ledger.amount.isZero()) {
    return undefined;
  }

  return ledger.marketValue.div(ledger.amount.abs());
}
